import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' }
});

// Attach auth token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('gm_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('gm_token');
      localStorage.removeItem('gm_user');
      if (window.location.pathname !== '/giris' && window.location.pathname !== '/kayit' && window.location.pathname !== '/') {
        window.location.href = '/giris';
      }
    }
    return Promise.reject(error);
  }
);

// Auth
export const authApi = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
};

// Restaurants
export const restaurantApi = {
  create: (data) => api.post('/restaurants', data),
  list: () => api.get('/restaurants'),
  get: (id) => api.get(`/restaurants/${id}`),
  checkSlug: (slug) => api.post('/restaurants/check-slug', { slug }),
};

// Menu
export const menuApi = {
  analyze: (data) => api.post('/menu/analyze', data),
  analyzeStatus: (jobId) => api.get(`/menu/analyze/status/${jobId}`),
  approve: (draftId, mergeMode = 'replace') => api.post('/menu/approve', { draft_id: draftId, merge_mode: mergeMode }),
  getItems: (restaurantId) => api.get(`/menu/${restaurantId}`),
  updateItem: (itemId, data) => api.put(`/menu/item/${itemId}`, data),
  deleteItem: (itemId) => api.delete(`/menu/item/${itemId}`),
  createItem: (data) => api.post('/menu/item', data),
  getDrafts: (restaurantId) => api.get(`/menu/drafts/${restaurantId}`),
};

// Stripe
export const stripeApi = {
  createCheckout: (data) => api.post('/stripe/create-checkout', data),
  checkoutStatus: (sessionId) => api.get(`/stripe/checkout-status/${sessionId}`),
};

// QR
export const qrApi = {
  generate: (restaurantId) => api.get(`/qr/${restaurantId}`),
};

// Export
export const exportApi = {
  getPdfHtml: (restaurantId) => api.get(`/export/pdf/${restaurantId}`),
};

// Restaurant settings
export const settingsApi = {
  setMenuFormat: (data) => api.post('/restaurants/menu-format', data),
};

// Public
export const publicApi = {
  getMenu: (slug) => axios.get(`${API_BASE}/public/menu/${slug}`),
};

export default api;
